module.exports = __webpack_public_path__ + "static/media/PR-1.06261894.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/PR-1.png
// module id = 99
// module chunks = 0